var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseFilterIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#FF1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.816 4.245a.75.75 0 00-1.06-1.061L6.5 5.439 4.245 3.184a.75.75 0 10-1.061 1.06L5.439 6.5 3.184 8.755a.75.75 0 101.06 1.061L6.5 7.561l2.255 2.255a.75.75 0 001.061-1.06L7.561 6.5l2.255-2.255z",
    fill: "#fff"
  })));
}
export default SvgCloseFilterIc;